/**
* Video Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Video Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'video-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.video-slider__splide' ).each( function( index, element ) {
        const slider = new Splide( $( element )[0], {
          type: 'loop',
          perPage: 2,
          drag: false,
          arrows: true,
          pagination: false,
          gap: '2rem',
          breakpoints: {
            768: {
              perPage: 1,
            },
          },
        } );
        slider.on( 'overflow', function( isOverflow ) {
          slider.options = {
            arrows: isOverflow,
            drag: isOverflow,
          };
        } );
        slider.mount();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'video-slider', COMPONENT );
} )( app );
